import React from 'react';

/**
 * Reusable modal wrapper.
 * Click the dark backdrop or the ✕ button to close.
 */
export default function Modal({ title, onClose, children }) {
  return (
    <div
      className="modal-overlay"
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-box">
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">{title}</div>
        {children}
      </div>
    </div>
  );
}